import {Button, Col, Row} from "reactstrap";
import React, {useEffect, useState} from "react";
import {useRouter} from "next/router";
import {useMutation, useQuery} from "@apollo/react-hooks";
import CAMPER_PICKUP_LOCATIONS from "../../../../graphql/queries/camperPickupLocations";
import moment from "moment/moment";
import Location from "./Location";
import Date from "./Date";
import SAVE_LAST_SELECTED_CAMPER_FILTER from "../../../../graphql/mutations/saveLastSelectedCamperFilter";
import {getSessionId} from "../../../../services/session";

const CamperSearch = ({paramsCanBeRetrievedFromUrl = false}) => {
    const router = useRouter();
    const sessionId = getSessionId();
    const country = router.query.destination;
    const [pickupLocations, setPickupLocations] = React.useState([]);
    const [pickupLocation, setPickupLocation] = useState(null);
    const [pickupDate, setPickupDate] = useState(null);
    const [dropOffLocation, setDropOffLocation] = useState(null);
    const [dropOffDate, setDropOffDate] = useState(null);

    const [saveLastSelectedCamperFilter] = useMutation(SAVE_LAST_SELECTED_CAMPER_FILTER, {
        onCompleted: (): void => {
            router.push({
                pathname: `/camper/${pickupLocation.seoId}`,
                query: {
                    inleverlocatie: dropOffLocation.label,
                    ophaaldatum: pickupDate.format('YYYY-MM-DD'),
                    inleverdatum: dropOffDate.format('YYYY-MM-DD'),
                }
            });
        }
    });

    const {loading, error, data} = useQuery(CAMPER_PICKUP_LOCATIONS);

    useEffect(() => {
        if (data && data.CamperPickupLocations && data.CamperPickupLocations.locations) {
            setPickupLocations(data.CamperPickupLocations.locations.map(location => {
                return {
                    label: location.location,
                    value: location.id,
                    seoId: location.seoId,
                }
            }));
        }
    }, [data])

    useEffect(() => {
        if (!paramsCanBeRetrievedFromUrl) {
            return;
        }

        const {inleverdatum, inleverlocatie, ophaaldatum} = router.query;
        setPickupLocation(pickupLocations.find(item => item.seoId === country));
        if (inleverlocatie) {
            setDropOffLocation(pickupLocations.find(item => item.label === inleverlocatie));
        }

        if (ophaaldatum) {
            setPickupDate(moment(ophaaldatum));
        }

        if (inleverdatum) {
            setDropOffDate(moment(inleverdatum));
        }
    }, [pickupLocations, router.query])

    const onSearchLinkClick = (): void => {
        saveLastSelectedCamperFilter({
            variables: {
                uuid: sessionId,
                searchFilter: {
                    pickupLocation: pickupLocation.label,
                    dropOffLocation: dropOffLocation.label,
                    pickupDate: pickupDate.format('YYYY-MM-DD'),
                    dropOffDate: dropOffDate.format('YYYY-MM-DD'),
                }
            },
        })
    }

    return (
        <Row>
            <Col
                lg="5"
            >
                <Location
                    location={pickupLocation}
                    setLocation={setPickupLocation}
                    locations={pickupLocations}
                    placeHolder="Kies een afhaallocatie"
                    label="Ophalen"
                    pickerId="pickupLocationPicker"
                    findChosenLocation={(camperFilter) => (location) => location.label === camperFilter.pickupLocation}
                    loadFromLastSelectedFilter={!paramsCanBeRetrievedFromUrl}
                />
                <Date
                    date={pickupDate}
                    setDate={setPickupDate}
                    isOutsideRange={(day) => dropOffDate ? !day.isAfter(dropOffDate) : false}
                    placeHolderText="Ophaal datum"
                    pickerId="pickup"
                    findSelectedDate={(camperFilter => moment(camperFilter.pickupDate))}
                    loadFromLastSelectedFilter={!paramsCanBeRetrievedFromUrl}
                />
            </Col>
            <Col
                lg="5"
            >
                <Location
                    location={dropOffLocation}
                    setLocation={setDropOffLocation}
                    locations={pickupLocations}
                    placeHolder="Kies een afleverlocatie"
                    label="Terugbrengen"
                    pickerId="dropOffLocationPicker"
                    findChosenLocation={(camperFilter) => (location) => location.label === camperFilter.dropOffLocation}
                    loadFromLastSelectedFilter={!paramsCanBeRetrievedFromUrl}
                />

                <Date
                    date={dropOffDate}
                    setDate={setDropOffDate}
                    isOutsideRange={(day) => pickupDate ? !day.isAfter(pickupDate) : false}
                    placeHolderText="Inlever datum"
                    pickerId="dropoff"
                    findSelectedDate={(camperFilter => moment(camperFilter.dropOffDate))}
                    loadFromLastSelectedFilter={!paramsCanBeRetrievedFromUrl}
                />
            </Col>
            <Col
                lg="2"
                className="align-self-end"
            >
                <Button
                    color="primary"
                    className="w-100 mb-2"
                    disabled={!(pickupLocation && dropOffLocation && pickupDate !== null && dropOffDate !== null)}
                    onClick={() => onSearchLinkClick()}
                >

                    <span className="d-lg-none">Vakantiehuis zoeken</span>
                    <span className="d-none d-lg-block">Zoeken</span>
                </Button>
            </Col>
        </Row>
    )
}

export default CamperSearch;
